export const paths = {
    playbookDetails: '/playbooks/:playbookId',
    playlistDetails: '/playlists/:playlistId',
    sharePlaybook: '/share/playbooks/:playbookId',
    sharePlaylist: '/share/playlists/:playlistId',
    ssoLogin: '/ssologin',
    ssoTenantLogin: '/ssologin/:tenantId',

    // Alternative path patterns
    playbookDetailsEUUnderscore: '/playbooks/eu_:playbookId',
    playlistDetailsEUUnderscore: '/playbooks/eu_playlists_:playlistId',
    playlistDetailsPlaybooksUnderscore: '/playbooks/playlists_:playlistId',
}
